const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_gJXRWTozr",
  client_id: "7gaoa7a5h2vib41nmc8p7k0j5i",
  redirect_uri:
    process.env.NODE_ENV === "development"
      ? "https://localhost:3000"
      : "https://internal.meedloyalty.com",
  response_type: "code",
  scope: "email openid profile",
};

export default cognitoAuthConfig;
